// Stripe configuration — safe to commit. Keys come from env (EAS: EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY).
// See https://docs.expo.dev/guides/environment-variables/

export const STRIPE_CONFIG = {
  publishableKey:
    process.env.EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY ||
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
    '',
  platformFeePercentage: 10,
  currency: 'usd',
};

export const DEFAULT_PLATFORM_FEE_PERCENTAGE = 10;

export default STRIPE_CONFIG;
